import { Injectable } from '@angular/core';
import { ApiEndPoints } from '../shared/config/api-end-points';
import { PagingConstant } from '../shared/constants/constants';
import { Observable } from 'rxjs';
import { Broker, BrokerBranch, BranchInformation } from '../models/broker';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpBaseService } from '../shared/services/http-base.service';
import { PaginationResponse } from '../models/pagination-response';

@Injectable({
  providedIn: "root",
})
export class BrokerBranchService {
  constructor(
    private http: HttpClient,
    private api: ApiEndPoints,
    private readonly _httpService: HttpBaseService
  ) {}

  getBrokerBranchesList(
    searchString: string,
    isIncludeInactive: boolean,
    sortField: string,
    sortDirection = "asc",
    pageIndex = PagingConstant.pageIndex,
    pageSize = PagingConstant.pageSize
  ): Observable<PaginationResponse<BranchInformation>> {
    return this.http
      .get<PaginationResponse<BranchInformation>>(
        this.api.getBrokerBranchesList(
          searchString,
          isIncludeInactive,
          sortField,
          sortDirection,
          pageIndex,
          pageSize
        )
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getBrokerBranchesByBrokerId(
    brokerId: string,
    searchString: string,
    isIncludeInactive: boolean,
    sortField: string,
    sortDirection = "asc",
    pageIndex = PagingConstant.pageIndex,
    pageSize = PagingConstant.pageSize
  ): Observable<PaginationResponse<BrokerBranch>> {
    return this.http
      .get<PaginationResponse<BrokerBranch>>(
        this.api.getBrokerBranchesByBrokerId(
          brokerId,
          searchString,
          isIncludeInactive,
          sortField,
          sortDirection,
          pageIndex,
          pageSize
        )
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
}
